import { ReactNode } from "react";
import { useNavigate } from "react-router";
// Mui
import Modal from "@mui/material/Modal";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// assets
import styles from "src/components/UI/Profile/assets/scss/base-widget-profile.module.scss";

interface BaseWidgetProps {
  onClose: () => void;
  modes: {
    editDetailsMode: boolean;
    editHeadMode: boolean;
    editAddressMode: boolean;
  };
  handleBack: () => void;
  children: ReactNode;
}
const BaseWidgetProfile = ({
  onClose,
  modes,
  handleBack,
  children,
}: BaseWidgetProps) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("..");

    onClose();
  };

  const handleBack_ = () => {
    handleBack();
  };

  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.box}>
        <Paper className={styles.header}>
          {modes.editDetailsMode ||
          modes.editHeadMode ||
          modes.editAddressMode ? (
            <KeyboardBackspaceIcon
              style={{ color: "#c3e7ff75", cursor: "pointer" }}
              onClick={handleBack_}
            />
          ) : (
            <Typography
              className={styles.headerText}
              variant="h1"
              component="h1"
            >
              {"My profile"}
            </Typography>
          )}
        </Paper>
        <IconButton
          className={styles.iconButton}
          disableRipple
          aria-label="Close"
          onClick={handleClose}
        >
          <CloseIcon
            sx={{ fontSize: "1rem", color: "#c3e7ff75", fontWeight: "900" }}
          />
        </IconButton>
        {children}
      </Box>
    </Modal>
  );
};
export default BaseWidgetProfile;
